import { Services } from '@smiles/voebiz-core-corporate-club';
// Serviço que recebe a flag se o membro tem o plano ativo
export const verifyActiveFlag = async (memberNumVoeBiz) => {
  const vbzDebug = localStorage.getItem('vbzDebug');

  try {
 

    const result = await Services.getParametersPurchaseMiles();

    const isActiveFlag = result.data?.activeForTeam;

    if (!isActiveFlag) {
      if (!window.location.hostname.includes('localhost') && !vbzDebug) {
        window.location.replace(`/presentear-milhas`);
      }
      return false;
    }
  } catch (error) {
    console.log(error);
    window.location.replace(`/presentear-milhas`);
    return false;
  }
  return true;
};
